import { handleActions } from 'redux-actions';
import { CAPS, MERCHANT_NO_MID } from '../constants';

const init = {
  noMid: false,
  isPollingRequested: false,
  // merchants
  isMerchantInit: false,
  isListDocumentsInit: false,
  isFetchingListDocuments: false,
  isProductsInit: false,
  isFetchingMerchant: false,
  isPreAssessmentFetched: false,
  isFetchingPreAssessmentStatus: false,
  isValidatingWidget: false,

  isActivatingProduct: false,
  isAddingProducts: false,
  isGeneratingCredentials: false,
  isFetchingCredentials: false,
  // products
  isFetchingProducts: false,
  // platforms
  isFetchingPlatforms: false,
  isAddingBankAccounts: false,

  isCreatingUser: false,
};

export default handleActions(
  {
    // merchants
    [MERCHANT_NO_MID]: state => ({
      ...state,
      noMid: true,
      isMerchantInit: true,
    }),
    [CAPS.V2_MERCHANTS_GET.LOADING]: state => ({
      ...state,
      isFetchingMerchant: true,
    }),
    [CAPS.V2_MERCHANTS_GET]: state => ({
      ...state,
      isMerchantInit: true,
      isFetchingMerchant: false,
    }),
    [CAPS.V2_DOC_LIST.LOADING]: state => ({
      ...state,
      isFetchingListDocuments: true,
    }),
    [CAPS.V2_DOC_LIST]: state => ({
      ...state,
      isListDocumentsInit: true,
      isFetchingListDocuments: false,
    }),
    [CAPS.V2_PRE_ASSESSMENT_GET]: state => ({ ...state, isPreAssessmentFetched: true }),
    [CAPS.V2_PRE_ASSESSMENT_UNDERWRITING_STATUS_GET.LOADING]: state => ({
      ...state,
      isFetchingPreAssessmentStatus: true,
    }),
    [CAPS.V2_PRE_ASSESSMENT_UNDERWRITING_STATUS_GET]: state => ({
      ...state,
      isFetchingPreAssessmentStatus: false,
    }),
    [CAPS.V2_MERCHANTS_PRODUCTS_PUT.LOADING]: state => ({
      ...state,
      isAddingProducts: true,
    }),
    [CAPS.V2_MERCHANTS_PRODUCTS_PUT]: state => ({
      ...state,
      isAddingProducts: false,
    }),
    [CAPS.MERCHANTS_CREDENTIALS_POST.LOADING]: state => ({
      ...state,
      isGeneratingCredentials: true,
    }),
    [CAPS.MERCHANTS_CREDENTIALS_POST]: state => ({
      ...state,
      isGeneratingCredentials: false,
    }),
    [CAPS.MERCHANTS_CREDENTIALS_GET.LOADING]: state => ({
      ...state,
      isFetchingCredentials: true,
    }),
    [CAPS.MERCHANTS_CREDENTIALS_GET]: state => ({
      ...state,
      isFetchingCredentials: false,
    }),
    // products
    [CAPS.V2_PRODUCTS_GET.LOADING]: state => ({
      ...state,
      isFetchingProducts: true,
    }),
    [CAPS.V2_PRODUCTS_GET]: state => ({
      ...state,
      isFetchingProducts: false,
      isProductsInit: true,
    }),
    // platforms
    [CAPS.V2_PLATFORMS_GET.LOADING]: state => ({
      ...state,
      isFetchingPlatforms: true,
    }),
    [CAPS.V2_PLATFORMS_GET]: state => ({
      ...state,
      isFetchingPlatforms: false,
    }),
    [CAPS.V2_MERCHANTS_ADDITIONAL_PRODUCTS_POST]: state => ({
      ...state,
      isActivatingProduct: false,
    }),
    [CAPS.V2_MERCHANTS_ADDITIONAL_PRODUCTS_POST.LOADING]: state => ({
      ...state,
      isActivatingProduct: true,
    }),
    [CAPS.V2_MERCHANTS_BANK_ACCOUNT_PUT]: state => ({
      ...state,
      isAddingBankAccounts: false,
    }),
    [CAPS.V2_MERCHANTS_BANK_ACCOUNT_PUT.LOADING]: state => ({
      ...state,
      isAddingBankAccounts: true,
    }),
    [CAPS.V2_WIDGET_TOKEN_GET]: state => ({
      ...state,
      isValidatingWidget: false,
    }),
    [CAPS.V2_WIDGET_TOKEN_GET.LOADING]: state => ({
      ...state,
      isValidatingWidget: true,
    }),
    [CAPS.SETUP_POST]: state => ({
      ...state,
      isCreatingMerchant: false,
    }),
    [CAPS.SETUP_POST.LOADING]: state => ({
      ...state,
      isCreatingMerchant: true,
    }),
    [CAPS.BPC_GET.LOADING]: state => ({
      ...state,
      isFetchingBpc: true,
    }),
    [CAPS.BPC_GET]: state => ({
      ...state,
      isFetchingBpc: false,
    }),
  },
  init,
);
